// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"b848ae43","65":"8839c236","434":"cb4dc4d9","522":"235fc6d7","537":"de91fa58","721":"906f8cee"}[chunkId] + ".css";
};